import Bugsnag from "@bugsnag/js";

function isExceptionEvent(
  error: Error | OT.OTError | OT.ExceptionEvent,
): error is OT.ExceptionEvent {
  return (error as OT.ExceptionEvent).title !== undefined;
}

export default function LogError(
  error: Error | OT.OTError | OT.ExceptionEvent,
) {
  if (isExceptionEvent(error)) {
    Bugsnag.notify({ name: error.title, message: error.message });
  } else {
    Bugsnag.notify(error);
  }
}
